module.exports = __webpack_public_path__ + "static/img/14.262b92d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blog/14.png
// module id = vbDv
// module chunks = 1